import {
  Modal,
  Button,
  ModalBody,
  ModalHeader,
  Input,
  Label,
  FormGroup,
  Form,
  Spinner,
} from "reactstrap";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { assignedDriverToOrder } from "store/actions/orderActions";
import { getRestaurantDrivers } from "store/actions/driverAction";

function AssignDriver({
  openModal,
  assignToggle,
  selectedOrderId,
  onAssignmentComplete,
}) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { drivers, isLoading } = useSelector((state) => state.driver);

  const [driver, setDriver] = useState("");
  const [driversList, setDriversList] = useState([]);
  const [isAssigning, setIsAssigning] = useState(false);

  useEffect(() => {
    const now = new Date();
    const twoHoursInMs = 2 * 60 * 60 * 1000;

    const filteredDrivers = drivers.filter((driver) => {
      if (!driver.isVerified) return false;

      if (!driver.isAssigned) return true;

      if (!driver.lastAssignedAt) return true;

      const lastAssignedAt =
        driver.lastAssignedAt?.toDate?.() || new Date(driver.lastAssignedAt);

      return now - lastAssignedAt >= twoHoursInMs;
    });

    setDriversList(filteredDrivers);
  }, [drivers]);

  const handleSave = (e) => {
    e.preventDefault();

    if (!driver) {
      return;
    }

    setIsAssigning(true);

    const payload = {
      orderId: selectedOrderId,
      driverId: driver,
    };

    dispatch(
      assignedDriverToOrder(payload, () => {
        assignToggle();
        dispatch(getRestaurantDrivers(user?.restaurantID));
        if (onAssignmentComplete) {
          onAssignmentComplete(selectedOrderId);
        }
        setIsAssigning(false);
      })
    );

    setTimeout(() => {
      setIsAssigning(false);
    }, 5000);
  };

  useEffect(() => {
    if (!openModal) {
      setIsAssigning(false);
    }
  }, [openModal]);

  return (
    <Modal isOpen={openModal} toggle={assignToggle}>
      <ModalHeader toggle={assignToggle}>
        Assign Driver to Deliver Order
      </ModalHeader>
      <ModalBody>
        <Form onSubmit={handleSave}>
          <FormGroup>
            <Label for="availableDriversSelect">Available Drivers</Label>
            {driversList && driversList.length > 0 ? (
              <Input
                id="availableDriversSelect"
                name="driver"
                type="select"
                className="text-capitalize"
                value={driver}
                onChange={(e) => setDriver(e.target.value)}
              >
                <option value="">Select a Driver</option>
                {driversList.map((driver) => (
                  <option
                    key={driver?.id}
                    value={driver?.id}
                    className="text-capitalize"
                  >
                    {driver?.name || "Unnamed Driver"}
                  </option>
                ))}
              </Input>
            ) : (
              <div className="alert alert-warning mt-2 mb-0" role="alert">
                🚫 No drivers available at the moment. Please check back later.
              </div>
            )}
          </FormGroup>

          <div className="d-flex justify-content-end">
            <Button color="secondary" onClick={assignToggle}>
              Cancel
            </Button>
            <Button
              disabled={
                isAssigning || isLoading || !driversList?.length || !driver
              }
              color="primary"
              type="submit"
              className="ms-2"
            >
              {isAssigning || isLoading ? <Spinner size="sm" /> : "Assign"}
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
}

export default AssignDriver;
